// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__rPAzT","error":"Textarea_error__gzugT","readonly":"Textarea_readonly__25PbD","disabled":"Textarea_disabled__1HnHh"};